import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Alert from '../../utils/Alert';

import Spinner from "../../components/generics/Spinner";

import { fetchVendors, fetchVendorsSuccess, fetchVendorsFailure } from "../../store/invoices/actions";
import { createPurchaseOrder, createPurchaseOrderSuccess, createPurchaseOrderFailure } from "../../store/purchaseOrders/actions";

import PurchaseOrderCreateForm from "../../components/purchaseOrders/PurchaseOrderCreateForm";
import { withRouter } from "utils/WithRouter";

export class PurchaseOrderCreateContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vendor: -1,
      submitting: false,
      error: false,
    };

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.vendors.length === 0) {
      this.props.fetchVendors(this.props);
    }
  }

  handleVendorChange = (event) => {
    if (event.target.value > -1) {
      var vendor = this.props.vendors.results[event.target.value];
      this.setState({ vendor: vendor.id, vendorName: vendor.name, error: false });
    } else {
      this.setState({ vendor: -1, vendorName: "", error: false });
    }
  }

  submitPurchaseOrder = () => {
    this.setState({ submitting: true });
    var data = new FormData();
    if (this.state.vendor !== -1) {
      data.append("vendor", this.state.vendor);
      this.props.createPurchaseOrder(data, this.props);
    } else {
      let error = this.state.error;
      if (this.state.vendor === -1) {
        error = true;
      }
      this.setState({ submitting: false, error }, () => {
        this.alertRef.current.sendAlert("Please, choose a vendor.");
      });
    }
  }

  cancelPurchaseOrder = () => {
    this.props.history.push("/purchase_orders/");
  }

  render() {
    if (this.props.loading) {
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>
      );
    } else {
      return (
        <Fragment>
          <Alert ref={this.alertRef}/>
          <PurchaseOrderCreateForm
            vendors={this.props.vendors.results}
            onVendorChange={this.handleVendorChange}
            submitPurchaseOrder={this.submitPurchaseOrder}
            cancelPurchaseOrder={this.cancelPurchaseOrder}
            error={this.state.error}
          />
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    vendorsList: state.invoices.vendorsList,
    vendors: state.invoices.vendorsList.vendors,
    loading: state.invoices.vendorsList.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  const finished = (data, props) => {
    props.history.push("/purchase_orders/" + data.id);
  };
  return {
    fetchVendors: (props) => {
      dispatch(fetchVendors()).payload.then(
        (response) => {
          dispatch(fetchVendorsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchVendorsFailure(error));
        }
      );
    },
    createPurchaseOrder: (data, props) => {
      dispatch(createPurchaseOrder(data)).payload.then(
        (response) => {
          finished(response.data, props);
          dispatch(createPurchaseOrderSuccess(response.data));
        },
        (error) => {
          dispatch(createPurchaseOrderFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderCreateContainer));
